module.exports = __webpack_public_path__ + "img/logo-fastbridge.0db5dd5b.png";